import type { TargetingBaseType } from 'sonata-static-storage/lib/schemas/targeting/TargetingBaseType';
import type { TagItem } from '@/components/common/FormExpandableSection/FormExpandableSection';

export function getMediaQualityTags(mediaQuality?: TargetingBaseType['mediaQuality']): TagItem[] {
  const result: TagItem[] = [];
  if (!mediaQuality) {
    return result;
  }
  if (mediaQuality.attentionRateMeasurement?.enabled) {
    result.push({ label: 'Lumen Attention Measurement' });
  }
  if (mediaQuality.brandSafety?.enabled) {
    result.push({ label: 'Brand Safety' });
  }
  if (mediaQuality.adFraud?.enabled) {
    result.push({ label: 'Ad Fraud' });
  }
  if (mediaQuality.viewabilityPrebid?.enabled) {
    result.push({ label: 'Viewability PRE BID' });
  }
  if (mediaQuality.viewabilityMeasurement?.enabled) {
    result.push({ label: 'Viewability POST BID' });
  }

  return result;
}
